import { ApiResponse, GlobalStore, GridStore } from '@roc/feature-app-core';
import { BorrowerLoansService } from '../services/borrowerLoansService';
import { GENERIC_ERROR_MESSAGE } from '@roc/feature-utils';

const PAGE_SIZE = 10;
export class BorrowerPipelineLoansGridStore extends GridStore {
  globalStore: GlobalStore;
  borrowerLoansService: BorrowerLoansService;

  private offsets: [number, number] = [0, 0];

  constructor(globalStore: GlobalStore) {
    super(() => this.fetchBorrowerPipelineLoans(), undefined, PAGE_SIZE);
    this.globalStore = globalStore;
    this.borrowerLoansService = new BorrowerLoansService();
  }

  reset() {
    super.reset();
    this.offsets = [0, 0];
  }

  *setPageNumber(pageNumber, fetch = true): any {
    this.offsets = pageNumber === 1 ? [0, 0] : this.offsets;
    yield super.setPageNumber(pageNumber, fetch);
  }

  fetchBorrowerPipelineLoans = async () => {
    try {
      const isPropertyManager = this.globalStore.userFeatures?.isBorrowerPropertyManager;
      if (isPropertyManager) {
        return await this.borrowerLoansService.getPropertyManagerPipelineLoansGrid(
          this.gridData.meta.pageNumber,
          this.gridData.meta.pageSize,
          this.gridData.meta.sortDir,
          this.gridData.meta.sortBy,
          this.gridData.meta.filters,
          this.gridData.meta.dropdownFilters
        );
      }
      const response = await this.borrowerLoansService.getBorrowerPipelineLoansGrid(
        this.gridData.meta.pageNumber,
        this.gridData.meta.pageSize,
        this.gridData.meta.sortDir,
        this.gridData.meta.sortBy,
        this.gridData.meta.filters,
        this.gridData.meta.dropdownFilters,
        this.offsets
      );
      return response;
    } catch (error) {
      this.globalStore.notificationStore.showErrorNotification({
        message: GENERIC_ERROR_MESSAGE
      });
    }
  };
}
